module.exports = __webpack_public_path__ + "static/media/ae.ffd94232.svg";